export default "__VITE_ASSET__bPDc$eTA__"